/* Phones (BNJMN, 4 Nov 2026): the header's Search icon works through the path line. Wherever the page is, it rolls to the top; the path deletes
   itself letter by letter back to "Home", types "/ Search/ " and waits with a blinking block caret for the word; the page's products fade away
   with it, and the Search panel's Suggestions + Featured show in the room. Typing shows matching suggestions, Enter searches, Esc restores.
   Pages without a path line (home, product pages, ...) keep opening the Search panel. Phones only (under 750px). */
(function () {
  const phone = window.matchMedia('(max-width: 749px)');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const DELETE_MS = 32;
  const TYPE_MS = 55;
  let running = false;
  let state = null;

  const esc = (t) => t.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const bold = (t, term) => {
    const at = t.toLowerCase().indexOf(term.toLowerCase());
    if (at < 0) return esc(t);
    return esc(t.slice(0, at)) + '<mark>' + esc(t.slice(at, at + term.length)) + '</mark>' + esc(t.slice(at + term.length));
  };
  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const findPath = () => {
    const row = document.querySelector('#MainContent .ve-picks--path');
    return row && row.offsetParent !== null ? row : null;
  };
  // the styles of the path line and the field, for pages that do not load them (product pages)
  const ensureCss = (names) => {
    const me = document.querySelector('script[src*="ve-path-search.js"]');
    if (!me) return Promise.resolve();
    return Promise.all(names.map((name) => new Promise((resolve) => {
      if (document.querySelector(`link[rel="stylesheet"][href*="${name}"]`)) { resolve(); return; }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = me.src.replace('ve-path-search.js', name);
      link.onload = resolve;
      link.onerror = resolve;
      document.head.appendChild(link);
      setTimeout(resolve, 2500);
    })));
  };
  // product pages have no path line at the top (the footer bar has the path): the line is made here, from that bar
  const canSynth = () => phone.matches && !!document.querySelector('#MainContent') && !!document.querySelector('.ve-pathbar[data-ve-pathbar="product"]');
  const makeSynth = () => {
    const bar = document.querySelector('.ve-pathbar[data-ve-pathbar="product"]');
    const row = document.createElement('div');
    row.className = 've-picks ve-picks--path ve-ui ve-pt-synth';
    row.style.marginBlockStart = '36px'; // path row top 98px like the collections
    const orig = document.createElement('span');
    orig.textContent = bar.textContent.replace(/\s+/g, ' ').trim();
    row.appendChild(orig);
    document.querySelector('#MainContent').prepend(row);
    return row;
  };
  const pathText = (row) => {
    const copy = row.cloneNode(true);
    copy.querySelectorAll('button, .ve-picks__clear, .ve-search-count, form, svg, .ve-picks__caret').forEach((n) => n.remove());
    return copy.textContent.replace(/\s+/g, ' ').trim();
  };
  const gridParts = (synth) => (synth ? document.querySelectorAll('#MainContent > *:not(.ve-pt-synth)') : document.querySelectorAll('#product-grid, #ProductGridContainer .pagination-wrapper, .ve-cats, .ve-grid-switch'));

  async function scrollTop() {
    if (window.scrollY <= 1) return;
    window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' });
    for (let i = 0; i < 20 && window.scrollY > 1; i++) await wait(50);
    if (window.scrollY > 1) window.scrollTo(0, 0);
  }

  function finishField(row, typed, caret) {
    // the word's field, shown after "Home/ Search/ "
    const panel = document.createElement('div');
    panel.className = 've-ps';
    panel.innerHTML = '<div class="ve-ps__live" hidden><ul class="ve-ps__list" role="list"></ul><a class="ve-ps__all" href="#"></a></div><div class="ve-ps__rest"></div>';
    const source = document.querySelector('[data-ve-msearch-rest]');
    const rest = panel.querySelector('.ve-ps__rest');
    const live = panel.querySelector('.ve-ps__live');
    if (source) rest.innerHTML = source.innerHTML.replace(/ve-msearch__/g, 've-ps__');
    row.after(panel);
    const allLabel = (document.querySelector('[data-ve-msearch-all]') || {}).dataset;
    const form = document.createElement('form');
    form.className = 've-path-edit';
    form.action = `${base}search`;
    form.method = 'get';
    form.setAttribute('role', 'search');
    form.innerHTML = '<span class="ve-path-edit__text" aria-hidden="true"></span><input class="ve-path-edit__input" type="search" name="q" autocomplete="off" autocapitalize="off" spellcheck="false"><input type="hidden" name="options[prefix]" value="last">';
    const input = form.querySelector('input[type=search]');
    const text = form.querySelector('.ve-path-edit__text');
    const clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 've-path-edit__clear';
    clear.textContent = '×';
    clear.hidden = true;
    input.setAttribute('aria-label', (document.querySelector('[data-ve-msearch-open]') || {}).ariaLabel || 'Search');
    typed.after(form);
    form.after(clear);
    form.querySelector('.ve-path-edit__text').after(caret);
    let token = 0;
    let timer = 0;
    const update = async () => {
      const term = input.value.trim();
      text.textContent = input.value;
      clear.hidden = !input.value;
      if (!term) { live.hidden = true; rest.hidden = false; token++; return; }
      const mine = ++token;
      try {
        const response = await fetch(`${base}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=collection,query,product&resources[limit]=10`);
        if (!response.ok) throw new Error(response.status);
        const data = (await response.json()).resources?.results || {};
        if (mine !== token) return;
        const rows = [];
        const seen = new Set();
        const add = (html, label, href) => {
          const key = label.toLowerCase();
          if (seen.has(key)) return;
          seen.add(key);
          rows.push(`<li><a href="${href}">${html}</a></li>`);
        };
        (data.collections || []).forEach((c) => add(bold(c.title, term), c.title, c.url));
        (data.queries || []).forEach((q) => add((q.styled_text || esc(q.text)).replace(/<(?!\/?mark>)[^>]*>/g, ''), q.text, q.url));
        live.querySelector('ul').innerHTML = rows.slice(0, 6).join('');
        const count = (data.products || []).length;
        const all = live.querySelector('.ve-ps__all');
        all.href = `${base}search?q=${encodeURIComponent(term)}&options%5Bprefix%5D=last`;
        all.textContent = `${(allLabel && allLabel.label) || 'See all results'}${count ? ` (${count >= 10 ? '10+' : count})` : ''}`;
        live.hidden = false;
        rest.hidden = true;
      } catch (error) {
        // suggestions are a convenience: Enter still searches
      }
    };
    input.addEventListener('input', () => { text.textContent = input.value; clear.hidden = !input.value; clearTimeout(timer); timer = setTimeout(update, 150); });
    clear.addEventListener('click', () => { input.value = ''; update(); input.focus({ preventScroll: true }); });
    form.addEventListener('submit', (event) => { if (!input.value.trim()) event.preventDefault(); });
    input.focus({ preventScroll: true });
    return { panel, form, clear, caret, typed };
  }

  function leave() {
    if (!state) return;
    const { row, parts, parts_style, field } = state;
    if (field) { field.panel.remove(); field.form.remove(); field.clear.remove(); field.caret.remove(); field.typed.remove(); }
    if (state.synth) row.remove();
    row.classList.remove('ve-pt-on');
    document.documentElement.classList.remove('ve-pt-active');
    parts.forEach((el, i) => { el.style.transition = ''; el.style.opacity = parts_style[i]; });
    state = null;
    running = false;
  }

  async function start() {
    if (running) return;
    let row = findPath();
    const synth = !row;
    if (synth && !canSynth()) return;
    running = true;
    await scrollTop();
    await ensureCss(['ve-menu-picks.css', 've-side-layout.css']);
    if (synth) row = makeSynth();
    const full = pathText(row);
    const parts = Array.from(gridParts(synth));
    const parts_style = parts.map((el) => el.style.opacity);
    const typed = document.createElement('span');
    typed.className = 've-pt-live';
    const caret = document.createElement('span');
    caret.className = 've-picks__caret';
    caret.setAttribute('aria-hidden', 'true');
    typed.textContent = full;
    row.classList.add('ve-pt-on');
    row.prepend(typed);
    typed.after(caret);
    document.documentElement.classList.add('ve-pt-active');
    state = { row, parts, parts_style, field: null, synth };
    // the search results page has its own field (assets/ve-search-path.js)
    const onSearchPage = !!document.querySelector('.ve-search-results [data-ve-ps-input]');
    const keep = 'Home';
    const homeEnd = full.indexOf('/') > 0 ? full.indexOf('/') : keep.length;
    const target = full.slice(0, homeEnd);
    const add = '/ Search/ ';
    const steps = (full.length - target.length) + add.length;
    const total = reduce.matches ? 0 : (full.length - target.length) * DELETE_MS + add.length * TYPE_MS;
    parts.forEach((el) => { el.style.transition = `opacity ${total}ms linear`; });
    setTimeout(() => parts.forEach((el) => { el.style.opacity = '0'; }), 30);
    if (!reduce.matches) {
      for (let n = full.length - 1; n >= target.length; n--) { typed.textContent = full.slice(0, n); await wait(DELETE_MS); }
      for (let n = 1; n <= add.length; n++) { typed.textContent = target + add.slice(0, n); await wait(TYPE_MS); }
    } else {
      typed.textContent = target + add;
    }
    document.documentElement.classList.add('ve-pt-done');
    // the Categories row keeps its place (visibility, not display), so the path does not jump up when the page clears
    parts.forEach((el) => { if (el.matches('.ve-cats, .ve-grid-switch')) el.style.visibility = 'hidden'; else el.style.display = 'none'; });
    if (onSearchPage && window.veSearchPath) {
      typed.remove(); caret.remove();
      row.classList.remove('ve-pt-on');
      parts.forEach((el) => { el.style.display = ''; el.style.visibility = ''; });
      state = null;
      running = false;
      window.veSearchPath.enter();
      return;
    }
    state.field = finishField(row, typed, caret);
    state.parts_style = parts_style;
    parts.forEach((el) => { el.dataset.vePtHidden = '1'; });
  }

  function restoreDisplay() {
    document.querySelectorAll('[data-ve-pt-hidden]').forEach((el) => { el.style.display = ''; el.style.visibility = ''; delete el.dataset.vePtHidden; });
    document.documentElement.classList.remove('ve-pt-done');
  }

  document.addEventListener('click', (event) => {
    if (!phone.matches) return;
    const icon = event.target.closest('[data-ve-msearch-open]');
    if (!icon) return;
    if (!findPath() && !canSynth()) return; // no path line on this page: the Search panel opens as before
    event.preventDefault();
    event.stopImmediatePropagation();
    if (state && state.field) { state.field.form.querySelector('input[type=search]').focus({ preventScroll: true }); return; }
    start();
  }, true);
  document.addEventListener('keyup', (event) => {
    if (event.code === 'Escape' && state) { restoreDisplay(); leave(); }
  });
  phone.addEventListener('change', (event) => { if (!event.matches && state) { restoreDisplay(); leave(); } });
})();
